import * as constants from "../utils_new/Constants";
import { CLASS_LABELS_OTHER } from "../partdetection_new/NewPartDetector";

export class PartCoverageEstimatorStencil {
  constructor() {

    // Setting parts that have orientation i.e. left and right.
    this.orientatedParts = [
        "fender",
        "qtr_panel",
        "window_glass",
        "front_door",
        "back_door",
        "running_board",
        ];
    this.extraOrientatedParts = [
          "front_bumper_isometric",
          "back_bumper_isometric",
        ];
    this.boxBorderThresholdForEachPart = {};
    this.partsCoveredMap = {};
    this.partsCoveredFramesCountMap = {};
    this.defaultBorderThreshold = {
      top: 0.03,
      bottom: 0.97,
      left: 0.03,
      right: 0.97,
    };
    for (let id in CLASS_LABELS_OTHER) {
      let label = CLASS_LABELS_OTHER[id];
      this.boxBorderThresholdForEachPart[label] = this.defaultBorderThreshold;
    }

    this.extraOrientatedParts.forEach((label) => {
      this.boxBorderThresholdForEachPart[label] = this.defaultBorderThreshold;
    });
    // We ignored the back glass because its detection rate is very low. That’s why we only want to consider 
    //dickeys that appear in the center of the image. Our assumption is that if the dickey is centered in the 
    //frame, the back glass should also be clearly visible and fully captured.
    this.boxBorderThresholdForEachPart["dicky"] = {
        top: 0.27,
        bottom: 0.85,
        left: 0.04,
        right: 0.96,
      }
    this.boxBorderThresholdForEachPart["hood"] = {
        top: 0.25,
        bottom: 0.85,
        left: 0.04,
        right: 0.96,
      }
      
    //Similar to back glass, the detection of the running board is also low. That’s why we want the door to 
    //appear slightly higher in the frame. In this way, the running board will automatically be fully captured.
    
    this.boxBorderThresholdForEachPart['back_door'] = {
      top: 0.04,
      bottom: 0.85,
      left: 0.04,
      right: 0.96,
      }
    this.boxBorderThresholdForEachPart['front_door'] = {
      top: 0.04,
      bottom: 0.85,
      left: 0.04,
      right: 0.96,
      }
    this.boxBorderThresholdForEachPart['back_bumper'] = {
        top: 0.04,
        bottom: 0.94,
        left: 0.04,
        right: 0.96,
      }
      this.boxBorderThresholdForEachPart['front_bumper'] = {
        top: 0.04,
        bottom: 0.94,
        left: 0.04,
        right: 0.96,
      }
  }
  getPartsCovered(boundingBoxDetections, angle) {
    let partsCoveredInAFrame = [];
    let orientation;

    // Determine Orientation based on the Angle.
    if (angle >= 20 && angle <= 160) orientation = "Right";
    else if (angle >= 200 && angle <= 340) orientation = "Left";
    else orientation = "Unclear";

    // Iterate through each Detection
    boundingBoxDetections.forEach((detection) => {
      let label = detection["label"];
      let x = detection["bbox"][0];
      let y = detection["bbox"][1];
      let width = detection["bbox"][2];
      let height = detection["bbox"][3];
      //console.log(label, "label++++++++++++++++++++++++++++++++++++++++++++++")

      // Check if the bboxes are not too close to the borders of the image, based on thresholds.
      let boxIsHorizontallyCovered =
        x >= this.boxBorderThresholdForEachPart[label]["left"] &&
        x + width <= this.boxBorderThresholdForEachPart[label]["right"];
      let boxIsVerticallyCovered =
        y >= this.boxBorderThresholdForEachPart[label]["top"] &&
        y + height <= this.boxBorderThresholdForEachPart[label]["bottom"];

      // Add the parts (and the orientation if applicable) to the list.
      if (boxIsHorizontallyCovered && boxIsVerticallyCovered) {
        if (
          this.orientatedParts.includes(label)
        ) {
          if (orientation !== "Unclear")
            partsCoveredInAFrame.push(orientation.toLowerCase() + "_" + label);
        } else partsCoveredInAFrame.push(label);
      }
    });
    return partsCoveredInAFrame;
  }

  // getPartsCovered(boundingBoxDetections) {
  //   return boundingBoxDetections
  //     .filter(({ label, bbox: [x, y, width, height] }) => {
  //       const threshold = this.boxBorderThresholdForEachPart[label];
  //       if (!threshold) return false;
  //       return (
  //         x >= threshold.left &&
  //         x + width <= threshold.right &&
  //         y >= threshold.top &&
  //         y + height <= threshold.bottom
  //       );
  //     })
  //     .map((detection) => detection.label);
  // }

  getPartsCoveredWithConfidence(boundingBoxDetections) {
    const partsCovered = this.getPartsCovered(boundingBoxDetections);
    return partsCovered;
  }

  setActualPartsCoveredMap(boundingBoxDetections) {
    const allParts = [...new Set(boundingBoxDetections.map((d) => d.label))];
    this.actualFrameCall = (this.actualFrameCall || 0) + 1;

    const partsCoveredWithConfidence = this.getPartsCoveredWithConfidence(
      boundingBoxDetections
    );

    const orientedPartsFullyCovered = new Set([
      "fender",
      "front_bumper",
      "window_glass",
      "hood",
      "left_front_bumper_isometric",
      "right_front_bumper_isometric",
      "front_glass",
      "qtr_panel",
      "qtr_panel",
      "back_bumper",
      "dicky",
      "left_back_bumper_isometric",
      "right_back_bumper_isometric",
      "back_glass",
      "front_door",
      "back_door",
      "running_board",
      "running_board",
    ]);

    const majorPartsSet = new Set(constants.ALL_MAJOR_PARTS);
    const fullyCoveredCount = partsCoveredWithConfidence.filter((part) =>
      orientedPartsFullyCovered.has(part)
    ).length;
    const majorPartsCount = allParts.filter((part) =>
      majorPartsSet.has(part)
    ).length;

    return majorPartsCount > 2 && fullyCoveredCount > 0;
  }
}
